module.exports = __webpack_public_path__ + "static/media/img-27.d4e2e1fa.jpg";